import qs from 'qs';
export class MeilisearchApi {
    constructor(baseUrl, apiKey) {
        this.apiKey = apiKey;
        this.baseUrl = baseUrl.endsWith('/') ? baseUrl.slice(1) : baseUrl;
    }
    /**
     * @throws {MeilisearchApi.ResponseError}
     */
    async request(method, path, args = {}) {
        let url = `${this.baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
        const headers = new Headers({
            'Content-Type': `application/json`,
        });
        if (this.apiKey) {
            headers.set('Authorization', `Bearer ${this.apiKey}`);
        }
        const options = { method, headers };
        if (method === 'GET') {
            url += '?' + qs.stringify(args);
        }
        else {
            options.body = JSON.stringify(args);
        }
        const resp = await fetch(url, options);
        if (resp.status === 200) {
            return await resp.json();
        }
        else {
            throw await resp.json();
        }
    }
    async search(indexId, args) {
        return await this.request('POST', `/indexes/${indexId}/search`, args);
    }
    async multiSearch(commonQuery, multiQueries) {
        const queries = [];
        for (const indexUid of Object.keys(multiQueries)) {
            const query = Object.assign({ indexUid }, commonQuery, multiQueries[indexUid]);
            queries.push(query);
        }
        const resultsArr = await this.request('POST', `/multi-search`, { queries })
            .then(resp => resp.results);
        const results = {};
        for (const result of resultsArr) {
            results[result.indexUid] = result;
        }
        return results;
    }
}
